const VTP_PLP_SESSION = 'VTP_PLP_SESSION';
export const getPLPSession = () => {
    if (typeof window !== 'undefined') {
        const key = VTP_PLP_SESSION;
        const stored = sessionStorage.getItem(key);
        return stored ? JSON.parse(stored) : {};
    }
    return {};
};
export const saveSortPLPSession = (payload) => {
    const storeName = VTP_PLP_SESSION;
    if (typeof window !== 'undefined') {
        const existingSession = getPLPSession();
        sessionStorage.setItem(storeName, JSON.stringify(Object.assign(Object.assign({}, existingSession), { sortingInSession: payload })));
    }
};
